import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {DataTableModule,SharedModule, ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule} from 'primeng/primeng';

import { VendorRoutingModule } from './vendor-routing.module';
import { VendorComponent } from './vendor.component';
import { VendorDetailComponent } from '../vendor-detail/vendor-detail.component';
import { VendorService } from './vendor.service';

@NgModule({
  imports: [
    CommonModule,
    VendorRoutingModule,
    FormsModule,
    DataTableModule,SharedModule, 
    ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule
  ],
  declarations: [VendorComponent, VendorDetailComponent],
  providers: [VendorService]
})
export class VendorModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/vendor/vendor.module.ts